import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { VideoProps } from "../types/competition";

export const MatchIntro: React.FC<VideoProps> = ({ competition }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const theme = competition.theme || {
    primaryColor: "#3B82F6",
    secondaryColor: "#EF4444",
    backgroundColor: "#1F2937",
  };

  // 动画
  const titleOpacity = interpolate(frame, [0, 30], [0, 1], {
    extrapolateRight: "clamp",
  });

  const titleY = spring({
    frame,
    fps,
    config: { damping: 100, stiffness: 200 },
  });

  const team1X = spring({
    frame: frame - 20,
    fps,
    config: { damping: 50 },
  });

  const team2X = spring({
    frame: frame - 20,
    fps,
    config: { damping: 50 },
  });

  const vsScale = spring({
    frame: frame - 40,
    fps,
    config: { damping: 10, stiffness: 100 },
  });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: theme.backgroundColor,
        fontFamily: "system-ui, sans-serif",
      }}
    >
      {/* 标题 */}
      <div
        style={{
          position: "absolute",
          top: 80,
          width: "100%",
          textAlign: "center",
          opacity: titleOpacity,
          transform: `translateY(${(1 - titleY) * -50}px)`,
        }}
      >
        <h1
          style={{
            color: "#fff",
            fontSize: 48,
            margin: 0,
            fontWeight: 700,
          }}
        >
          {competition.name}
        </h1>
        <p style={{ color: "#9CA3AF", fontSize: 24, marginTop: 12 }}>
          {competition.date} · {competition.location}
        </p>
      </div>

      {/* 队伍对阵 */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          alignItems: "center",
          gap: 60,
        }}
      >
        {/* 队伍 1 */}
        <div
          style={{
            transform: `translateX(${(1 - team1X) * -200}px)`,
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 150,
              height: 150,
              borderRadius: "50%",
              backgroundColor: theme.primaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <span style={{ fontSize: 48, color: "#fff" }}>
              {competition.teams[0]?.name.charAt(0)}
            </span>
          </div>
          <h2 style={{ color: "#fff", fontSize: 36, margin: 0 }}>
            {competition.teams[0]?.name}
          </h2>
        </div>

        {/* VS */}
        <div
          style={{
            transform: `scale(${vsScale})`,
            color: "#fff",
            fontSize: 72,
            fontWeight: 900,
            textShadow: "0 0 40px rgba(255,255,255,0.5)",
          }}
        >
          VS
        </div>

        {/* 队伍 2 */}
        <div
          style={{
            transform: `translateX(${(1 - team2X) * 200}px)`,
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 150,
              height: 150,
              borderRadius: "50%",
              backgroundColor: theme.secondaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <span style={{ fontSize: 48, color: "#fff" }}>
              {competition.teams[1]?.name.charAt(0)}
            </span>
          </div>
          <h2 style={{ color: "#fff", fontSize: 36, margin: 0 }}>
            {competition.teams[1]?.name}
          </h2>
        </div>
      </div>
    </AbsoluteFill>
  );
};
